module.exports = __webpack_public_path__ + "static/media/singular_hearing.0f3c0258.png";